export enum ReportsTypeEnum {
  HOUR,
  DAY,
  MONTH,
  EVENTS,
  CHANGES,
}
